import React, { useRef, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

// components
import {
  MainHolder,
  StyledText,
  DynamicButton,
} from "../../../../components/common";

//svgs
import { FileIcon } from "../../../../components/svgs";
import { useTheme } from "../../../../hooks";

// theme

const GetPinCard = ({ scratchCardCode, quantity }) => {
  const [showVoucher, setShowVoucher] = useState(false);
  const textRef = useRef(null);

  const { themeContext, theme } = useTheme();
  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];

  const handleShowVoucher = () => {
    setShowVoucher(!showVoucher);
  };

  const handleCopyClick = () => {
    const textArea = document.createElement("textarea");
    textArea.value = scratchCardCode;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    alert("code copied");
  };

  return (
    <MainHolder
      style={{
        display: "flex",
        flexDirection: "column",
        height: 150
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <StyledText>GHs 10 Airtime</StyledText>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          border: "1px dashed #7F7F7F",
          borderRadius: 15,
        }}
      >
        <StyledText ref={textRef}>{scratchCardCode}</StyledText>
        <div
          style={{
            display: "flex",
            backgroundColor: background,
            justifyContent: "center",
            alignItems: "center",
            width: 35,
            height: 26,
            borderRadius: 15,
          }}
          onClick={() => handleCopyClick()}
        >
          <FileIcon />
        </div>
      </div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <StyledText
          style={{ fontFamily: "MTNRegular", fontSize: 12, color: "#7F7F7F" }}
        >
          {quantity} pin{quantity < 2 ? "" : "s"} remaining
        </StyledText>
      </div>
    </MainHolder>
  );
};

export default GetPinCard;

const AlertCurveTop = styled.div`
  position: absolute;
  width: 225%;
  height: 70%;
  top: 30%;
  left: -62%;
  backgroundcolor: "#fff";
  border-top-left-radius: 50%;
  background-color: rgb(255, 255, 255);
  border-top-right-radius: 50%;
`;

const ButtonHolder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const AlertIconContainer = styled.div`
  margin: 0px auto;
  background-color: #e31c79;
  height: 100px;
  width: 100px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-items: center;
  justify-content: center;
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const BottomContent = styled.div`
  width: 80%;
  background-color: white;
  // box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  // border-radius: 8px;
  margin: 20px;
  padding: 15px;
  overflow: auto;
`;
